import { Flex, forwardRef } from "@chakra-ui/react";

export const GlobalContainer = forwardRef((props, ref) => {
  return <Flex id="ok" position="absolute" top="0" left="0" right="0" bottom="0" {...props} />;
});
